const allCountries = [
    ['Afghanistan (‫افغانستان‬‎)', 'Afghanistan', 'af', '93'],
    ['Albania (Shqipëri)', 'Albania', 'al', '355'],
    ['Algeria (‫الجزائر‬‎)', 'Algeria', 'dz', '213'],
    ['American Samoa', 'American Samoa', 'as', '1684'],
    ['Andorra', 'Andorra', 'ad', '376'],
    ['Angola', 'Angola', 'ao', '244'],
    ['Anguilla', 'Anguilla', 'ai', '1264'],
    ['Antigua and Barbuda', 'Antigua and Barbuda', 'ag', '1268'],
    ['Argentina', 'Argentina', 'ar', '54'],
    ['Armenia (Հայաստան)', 'Armenia', 'am', '374'],
    ['Aruba', 'Aruba', 'aw', '297'],
    ['Australia', 'Australia', 'au', '61', 0],
    ['Austria (Österreich)', 'Austria', 'at', '43'],
    ['Azerbaijan (Azərbaycan)', 'Azerbaijan', 'az', '994'],
    ['Bahamas', 'Bahamas', 'bs', '1242'],
    ['Bahrain (‫البحرين‬‎)', 'Bahrain', 'bh', '973'],
    ['Bangladesh (বাংলাদেশ)', 'Bangladesh', 'bd', '880'],
    ['Barbados', 'Barbados', 'bb', '1246'],
    ['Belarus (Беларусь)', 'Belarus', 'by', '375'],
    ['Belgium (België)', 'Belgium', 'be', '32'],
    ['Belize', 'Belize', 'bz', '501'],
    ['Benin (Bénin)', 'Benin', 'bj', '229'],
    ['Bermuda', 'Bermuda', 'bm', '1441'],
    ['Bhutan (འབྲུག)', 'Bhutan', 'bt', '975'],
    ['Bolivia', 'Bolivia', 'bo', '591'],
    ['Bosnia and Herzegovina (Босна и Херцеговина)', 'Bosnia and Herzegovina', 'ba', '387'],
    ['Botswana', 'Botswana', 'bw', '267'],
    ['Brazil (Brasil)', 'Brazil', 'br', '55'],
    ['British Indian Ocean Territory', 'British Indian Ocean Territory', 'io', '246'],
    ['British Virgin Islands', 'British Virgin Islands', 'vg', '1284'],
    ['Brunei', 'Brunei', 'bn', '673'],
    ['Bulgaria (България)', 'Bulgaria', 'bg', '359'],
    ['Burkina Faso', 'Burkina Faso', 'bf', '226'],
    ['Burundi (Uburundi)', 'Burundi', 'bi', '257'],
    ['Cambodia (កម្ពុជា)', 'Cambodia', 'kh', '855'],
    ['Cameroon (Cameroun)', 'Cameroon', 'cm', '237'],
    [
        'Canada',
        'Canada',
        'ca',
        '1',
        1,
        [
            '204',
            '226',
            '236',
            '249',
            '250',
            '289',
            '306',
            '343',
            '365',
            '387',
            '403',
            '416',
            '418',
            '431',
            '437',
            '438',
            '450',
            '506',
            '514',
            '519',
            '548',
            '579',
            '581',
            '587',
            '604',
            '613',
            '639',
            '647',
            '672',
            '705',
            '709',
            '742',
            '778',
            '780',
            '782',
            '807',
            '819',
            '825',
            '867',
            '873',
            '902',
            '905',
        ],
    ],
    ['Cape Verde (Kabu Verdi)', 'Cape Verde', 'cv', '238'],
    ['Caribbean Netherlands', 'Caribbean Netherlands', 'bq', '599', 1],
    ['Cayman Islands', 'Cayman Islands', 'ky', '1345'],
    ['Central African Republic (République centrafricaine)', 'Central African Republic', 'cf', '236'],
    ['Chad (Tchad)', 'Chad', 'td', '235'],
    ['Chile', 'Chile', 'cl', '56'],
    ['China (中国)', 'China', 'cn', '86'],
    ['Christmas Island', 'Christmas Island', 'cx', '61', 2],
    ['Colombia', 'Colombia', 'co', '57'],
    ['Comoros (‫جزر القمر‬‎)', 'Comoros', 'km', '269'],
    ['Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)', 'Congo (DRC)', 'cd', '243'],
    ['Congo (Republic) (Congo-Brazzaville)', 'Congo (Republic)', 'cg', '242'],
    ['Cook Islands', 'Cook Islands', 'ck', '682'],
    ['Costa Rica', 'Costa Rica', 'cr', '506'],
    ['Côte d’Ivoire', 'Côte d’Ivoire', 'ci', '225'],
    ['Croatia (Hrvatska)', 'Croatia', 'hr', '385'],
    ['Cuba', 'Cuba', 'cu', '53'],
    ['Curaçao', 'Curaçao', 'cw', '599', 0],
    ['Cyprus (Κύπρος)', 'Cyprus', 'cy', '357'],
    ['Czech Republic (Česká republika)', 'Czech Republic', 'cz', '420'],
    ['Denmark (Danmark)', 'Denmark', 'dk', '45'],
    ['Djibouti', 'Djibouti', 'dj', '253'],
    ['Dominica', 'Dominica', 'dm', '1767'],
    ['Dominican Republic (República Dominicana)', 'Dominican Republic', 'do', '1', 2, ['809', '829', '849']],
    ['Ecuador', 'Ecuador', 'ec', '593'],
    ['Egypt (‫مصر‬‎)', 'Egypt', 'eg', '20'],
    ['El Salvador', 'El Salvador', 'sv', '503'],
    ['Equatorial Guinea (Guinea Ecuatorial)', 'Equatorial Guinea', 'gq', '240'],
    ['Eritrea', 'Eritrea', 'er', '291'],
    ['Estonia (Eesti)', 'Estonia', 'ee', '372'],
    ['Ethiopia', 'Ethiopia', 'et', '251'],
    ['Falkland Islands (Islas Malvinas)', 'Falkland Islands', 'fk', '500'],
    ['Faroe Islands (Føroyar)', 'Faroe Islands', 'fo', '298'],
    ['Fiji', 'Fiji', 'fj', '679'],
    ['Finland (Suomi)', 'Finland', 'fi', '358', 0],
    ['France', 'France', 'fr', '33'],
    ['French Guiana (Guyane française)', 'French Guiana', 'gf', '594'],
    ['French Polynesia (Polynésie française)', 'French Polynesia', 'pf', '689'],
    ['Gabon', 'Gabon', 'ga', '241'],
    ['Gambia', 'Gambia', 'gm', '220'],
    ['Georgia (საქართველო)', 'Georgia', 'ge', '995'],
    ['Germany (Deutschland)', 'Germany', 'de', '49'],
    ['Ghana (Gaana)', 'Ghana', 'gh', '233'],
    ['Gibraltar', 'Gibraltar', 'gi', '350'],
    ['Greece (Ελλάδα)', 'Greece', 'gr', '30'],
    ['Greenland (Kalaallit Nunaat)', 'Greenland', 'gl', '299'],
    ['Grenada', 'Grenada', 'gd', '1473'],
    ['Guadeloupe', 'Guadeloupe', 'gp', '590', 0],
    ['Guam', 'Guam', 'gu', '1671'],
    ['Guatemala', 'Guatemala', 'gt', '502'],
    ['Guernsey', 'Guernsey', 'gg', '44', 1],
    ['Guinea (Guinée)', 'Guinea', 'gn', '224'],
    ['Guinea-Bissau (Guiné Bissau)', 'Guinea-Bissau', 'gw', '245'],
    ['Guyana', 'Guyana', 'gy', '592'],
    ['Haiti', 'Haiti', 'ht', '509'],
    ['Honduras', 'Honduras', 'hn', '504'],
    ['Hong Kong (香港)', 'Hong Kong', 'hk', '852'],
    ['Hungary (Magyarország)', 'Hungary', 'hu', '36'],
    ['Iceland (Ísland)', 'Iceland', 'is', '354'],
    ['India (भारत)', 'India', 'in', '91'],
    ['Indonesia', 'Indonesia', 'id', '62'],
    ['Iran (‫ایران‬‎)', 'Iran', 'ir', '98'],
    ['Iraq (‫العراق‬‎)', 'Iraq', 'iq', '964'],
    ['Ireland', 'Ireland', 'ie', '353'],
    ['Isle of Man', 'Isle of Man', 'im', '44', 2],
    ['Israel (‫ישראל‬‎)', 'Israel', 'il', '972'],
    ['Italy (Italia)', 'Italy', 'it', '39', 0],
    ['Jamaica', 'Jamaica', 'jm', '1876'],
    ['Japan (日本)', 'Japan', 'jp', '81'],
    ['Jersey', 'Jersey', 'je', '44', 3],
    ['Jordan (‫الأردن‬‎)', 'Jordan', 'jo', '962'],
    ['Kazakhstan (Казахстан)', 'Kazakhstan', 'kz', '7', 1],
    ['Kenya', 'Kenya', 'ke', '254'],
    ['Kiribati', 'Kiribati', 'ki', '686'],
    ['Kosovo', 'Kosovo', 'xk', '383'],
    ['Kuwait (‫الكويت‬‎)', 'Kuwait', 'kw', '965'],
    ['Kyrgyzstan (Кыргызстан)', 'Kyrgyzstan', 'kg', '996'],
    ['Laos (ລາວ)', 'Laos', 'la', '856'],
    ['Latvia (Latvija)', 'Latvia', 'lv', '371'],
    ['Lebanon (‫لبنان‬‎)', 'Lebanon', 'lb', '961'],
    ['Lesotho', 'Lesotho', 'ls', '266'],
    ['Liberia', 'Liberia', 'lr', '231'],
    ['Libya (‫ليبيا‬‎)', 'Libya', 'ly', '218'],
    ['Liechtenstein', 'Liechtenstein', 'li', '423'],
    ['Lithuania (Lietuva)', 'Lithuania', 'lt', '370'],
    ['Luxembourg', 'Luxembourg', 'lu', '352'],
    ['Macau (澳門)', 'Macau', 'mo', '853'],
    ['Macedonia (FYROM) (Македонија)', 'Macedonia', 'mk', '389'],
    ['Madagascar (Madagasikara)', 'Madagascar', 'mg', '261'],
    ['Malawi', 'Malawi', 'mw', '265'],
    ['Malaysia', 'Malaysia', 'my', '60'],
    ['Maldives', 'Maldives', 'mv', '960'],
    ['Mali', 'Mali', 'ml', '223'],
    ['Malta', 'Malta', 'mt', '356'],
    ['Marshall Islands', 'Marshall Islands', 'mh', '692'],
    ['Martinique', 'Martinique', 'mq', '596'],
    ['Mauritania (‫موريتانيا‬‎)', 'Mauritania', 'mr', '222'],
    ['Mauritius (Moris)', 'Mauritius', 'mu', '230'],
    ['Mayotte', 'Mayotte', 'yt', '262', 1],
    ['Mexico (México)', 'Mexico', 'mx', '52'],
    ['Micronesia', 'Micronesia', 'fm', '691'],
    ['Moldova (Republica Moldova)', 'Moldova', 'md', '373'],
    ['Monaco', 'Monaco', 'mc', '377'],
    ['Mongolia (Монгол)', 'Mongolia', 'mn', '976'],
    ['Montenegro (Crna Gora)', 'Montenegro', 'me', '382'],
    ['Montserrat', 'Montserrat', 'ms', '1664'],
    ['Morocco (‫المغرب‬‎)', 'Morocco', 'ma', '212', 0],
    ['Mozambique (Moçambique)', 'Mozambique', 'mz', '258'],
    ['Myanmar (Burma) (မြန်မာ)', 'Myanmar', 'mm', '95'],
    ['Namibia (Namibië)', 'Namibia', 'na', '264'],
    ['Nauru', 'Nauru', 'nr', '674'],
    ['Nepal (नेपाल)', 'Nepal', 'np', '977'],
    ['Netherlands (Nederland)', 'Netherlands', 'nl', '31'],
    ['New Caledonia (Nouvelle-Calédonie)', 'New Caledonia', 'nc', '687'],
    ['New Zealand', 'New Zealand', 'nz', '64'],
    ['Nicaragua', 'Nicaragua', 'ni', '505'],
    ['Niger (Nijar)', 'Niger', 'ne', '227'],
    ['Nigeria', 'Nigeria', 'ng', '234'],
    ['Niue', 'Niue', 'nu', '683'],
    ['Norfolk Island', 'Norfolk Island', 'nf', '672'],
    ['North Korea (조선 민주주의 인민 공화국)', 'North Korea', 'kp', '850'],
    ['Northern Mariana Islands', 'Northern Mariana Islands', 'mp', '1670'],
    ['Norway (Norge)', 'Norway', 'no', '47', 0],
    ['Oman (‫عُمان‬‎)', 'Oman', 'om', '968'],
    ['Pakistan (‫پاکستان‬‎)', 'Pakistan', 'pk', '92'],
    ['Palau', 'Palau', 'pw', '680'],
    ['Palestine (‫فلسطين‬‎)', 'Palestine', 'ps', '970'],
    ['Panama (Panamá)', 'Panama', 'pa', '507'],
    ['Papua New Guinea', 'Papua New Guinea', 'pg', '675'],
    ['Paraguay', 'Paraguay', 'py', '595'],
    ['Peru (Perú)', 'Peru', 'pe', '51'],
    ['Philippines', 'Philippines', 'ph', '63'],
    ['Poland (Polska)', 'Poland', 'pl', '48'],
    ['Portugal', 'Portugal', 'pt', '351'],
    ['Puerto Rico', 'Puerto Rico', 'pr', '1', 3, ['787', '939']],
    ['Qatar (‫قطر‬‎)', 'Qatar', 'qa', '974'],
    ['Réunion (La Réunion)', 'Réunion', 're', '262', 0],
    ['Romania (România)', 'Romania', 'ro', '40'],
    ['Russia (Россия)', 'Russia', 'ru', '7', 0],
    ['Rwanda', 'Rwanda', 'rw', '250'],
    ['Saint Barthélemy', 'Saint Barthélemy', 'bl', '590', 1],
    ['Saint Helena', 'Saint Helena', 'sh', '290'],
    ['Saint Kitts and Nevis', 'Saint Kitts and Nevis', 'kn', '1869'],
    ['Saint Lucia', 'Saint Lucia', 'lc', '1758'],
    ['Saint Martin (Saint-Martin (partie française))', 'Saint Martin', 'mf', '590', 2],
    ['Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)', 'Saint Pierre and Miquelon', 'pm', '508'],
    ['Saint Vincent and the Grenadines', 'Saint Vincent and the Grenadines', 'vc', '1784'],
    ['American Samoa', 'Samoa', 'ws', '685'],
    ['San Marino', 'San Marino', 'sm', '378'],
    ['São Tomé and Príncipe (São Tomé e Príncipe)', 'São Tomé and Príncipe', 'st', '239'],
    ['Saudi Arabia (‫المملكة العربية السعودية‬‎)', 'Saudi Arabia', 'sa', '966'],
    ['Senegal (Sénégal)', 'Senegal', 'sn', '221'],
    ['Serbia (Србија)', 'Serbia', 'rs', '381'],
    ['Seychelles', 'Seychelles', 'sc', '248'],
    ['Sierra Leone', 'Sierra Leone', 'sl', '232'],
    ['Singapore', 'Singapore', 'sg', '65'],
    ['Sint Maarten', 'Sint Maarten', 'sx', '1721'],
    ['Slovakia (Slovensko)', 'Slovakia', 'sk', '421'],
    ['Slovenia (Slovenija)', 'Slovenia', 'si', '386'],
    ['Solomon Islands', 'Solomon Islands', 'sb', '677'],
    ['Somalia (Soomaaliya)', 'Somalia', 'so', '252'],
    ['South Africa', 'South Africa', 'za', '27'],
    ['South Korea (대한민국)', 'South Korea', 'kr', '82'],
    ['South Sudan (‫جنوب السودان‬‎)', 'South Sudan', 'ss', '211'],
    ['Spain (España)', 'Spain', 'es', '34'],
    ['Sri Lanka (ශ්‍රී ලංකාව)', 'Sri Lanka', 'lk', '94'],
    ['South Sudan (‫جنوب السودان‬‎)', 'Sudan', 'sd', '249'],
    ['Suriname', 'Suriname', 'sr', '597'],
    ['Svalbard and Jan Mayen', 'Svalbard and Jan Mayen', 'sj', '47', 1],
    ['Swaziland', 'Swaziland', 'sz', '268'],
    ['Sweden (Sverige)', 'Sweden', 'se', '46'],
    ['Switzerland (Schweiz)', 'Switzerland', 'ch', '41'],
    ['Syria (‫سوريا‬‎)', 'Syria', 'sy', '963'],
    ['Taiwan (台灣)', 'Taiwan', 'tw', '886'],
    ['Tajikistan', 'Tajikistan', 'tj', '992'],
    ['Tanzania', 'Tanzania', 'tz', '255'],
    ['Thailand (ไทย)', 'Thailand', 'th', '66'],
    ['Timor-Leste', 'Timor-Leste', 'tl', '670'],
    ['Togo', 'Togo', 'tg', '228'],
    ['Tokelau', 'Tokelau', 'tk', '690'],
    ['Tonga', 'Tonga', 'to', '676'],
    ['Trinidad and Tobago', 'Trinidad and Tobago', 'tt', '1868'],
    ['Tunisia (‫تونس‬‎)', 'Tunisia', 'tn', '216'],
    ['Turkey (Türkiye)', 'Turkey', 'tr', '90'],
    ['Turkmenistan', 'Turkmenistan', 'tm', '993'],
    ['Turks and Caicos Islands', 'Turks and Caicos Islands', 'tc', '1649'],
    ['Tuvalu', 'Tuvalu', 'tv', '688'],
    ['U.S. Virgin Islands', 'U.S. Virgin Islands', 'vi', '1340'],
    ['Uganda', 'Uganda', 'ug', '256'],
    ['Ukraine (Україна)', 'Ukraine', 'ua', '380'],
    ['United Arab Emirates (‫الإمارات العربية المتحدة‬‎)', 'United Arab Emirates', 'ae', '971'],
    ['United Kingdom', 'United Kingdom', 'gb', '44', 0],
    ['United States', 'United States', 'us', '1', 0],
    ['Uruguay', 'Uruguay', 'uy', '598'],
    ['Uzbekistan (Oʻzbekiston)', 'Uzbekistan', 'uz', '998'],
    ['Vanuatu', 'Vanuatu', 'vu', '678'],
    ['Vatican City (Città del Vaticano)', 'Vatican City', 'va', '39', 1],
    ['Venezuela', 'Venezuela', 've', '58'],
    ['Vietnam (Việt Nam)', 'Vietnam', 'vn', '84'],
    ['Wallis and Futuna (Wallis-et-Futuna)', 'Wallis and Futuna', 'wf', '681'],
    ['Western Sahara (‫الصحراء الغربية‬‎)', 'Western Sahara', 'eh', '212', 1],
    ['Yemen (‫اليمن‬‎)', 'Yemen', 'ye', '967'],
    ['Zambia', 'Zambia', 'zm', '260'],
    ['Zimbabwe', 'Zimbabwe', 'zw', '263'],
    ['Åland Islands', 'Åland Islands', 'ax', '358', 1],
];

export const allCountriesInfo = allCountries.map(country => ({
    name: country[0],
    country: country[1],
    iso2: country[2].toUpperCase(),
    dialCode: country[3],
    priority: country[4] || 0,
    areaCodes: country[5] || null,
}));

